module.exports = __webpack_public_path__ + "static/media/color-picker.e966c17f.png";